export const professionalConstants = {
  GET_MASTER_REQUEST: "GET_MASTER_REQUEST",
  GET_MASTER_SUCCESS: "GET_MASTER_SUCCESS",
  GET_MASTER_FAILURE: "GET_MASTER_FAILURE",

  GET_CITY_REQUEST: "GET_CITY_REQUEST",
  GET_CITY_SUCCESS: "GET_CITY_SUCCESS",
  GET_CITY_FAILURE: "GET_CITY_FAILURE",

  GET_DISTRICT_BASICINFO_REQUEST: "GET_DISTRICT_BASICINFO_REQUEST",
  GET_DISTRICT_BASICINFO_SUCCESS: "GET_DISTRICT_BASICINFO_SUCCESS",
  GET_DISTRICT_BASICINFO_FAILURE: "GET_DISTRICT_BASICINFO_FAILURE",

  GET_DISTRICT_GUNHA_REQUEST: "GET_DISTRICT_GUNHA_REQUEST",
  GET_DISTRICT_GUNHA_SUCCESS: "GET_DISTRICT_GUNHA_SUCCESS",
  GET_DISTRICT_GUNHA_FAILURE: "GET_DISTRICT_GUNHA_FAILURE",

  GET_DHARM_REQUEST: "GET_DHARM_REQUEST",
  GET_DHARM_SUCCESS: "GET_DHARM_SUCCESS",
  GET_DHARM_FAILURE: "GET_DHARM_FAILURE",

  GET_KAYDA_REQUEST: "GET_KAYDA_REQUEST",
  GET_KAYDA_SUCCESS: "GET_KAYDA_SUCCESS",
  GET_KAYDA_FAILURE: "GET_KAYDA_FAILURE",

  GET_KALAM_REQUEST: "GET_KALAM_REQUEST",
  GET_KALAM_SUCCESS: "GET_KALAM_SUCCESS",
  GET_KALAM_FAILURE: "GET_KALAM_FAILURE",

  GET_CRIMETYPE_REQUEST: "GET_CRIMETYPE_REQUEST",
  GET_CRIMETYPE_SUCCESS: "GET_CRIMETYPE_SUCCESS",
  GET_CRIMETYPE_FAILURE: "GET_CRIMETYPE_FAILURE",

  GET_CRIMETITLE_REQUEST: "GET_CRIMETITLE_REQUEST",
  GET_CRIMETITLE_SUCCESS: "GET_CRIMETITLE_SUCCESS",
  GET_CRIMETITLE_FAILURE: "GET_CRIMETITLE_FAILURE",

  GET_STATUS_REQUEST: "GET_STATUS_REQUEST",
  GET_STATUS_SUCCESS: "GET_STATUS_SUCCESS",
  GET_STATUS_FAILURE: "GET_STATUS_FAILURE",

  GET_CREATE_CRIMINAL_REQUEST: "GET_CREATE_CRIMINAL_REQUEST",
  GET_CREATE_CRIMINAL_SUCCESS: "GET_CREATE_CRIMINAL_SUCCESS",
  GET_CREATE_CRIMINAL_FAILURE: "GET_CREATE_CRIMINAL_FAILURE",

  GET_CRIMINALS_BY_ID_REQUEST: "GET_CRIMINALS_BY_ID_REQUEST",
  GET_CRIMINALS_BY_ID_SUCCESS: "GET_CRIMINALS_BY_ID_SUCCESS",
  GET_CRIMINALS_BY_ID_FAILURE: "GET_CRIMINALS_BY_ID_FAILURE",

  UPDATE_CRIMINALS_BY_ID_REQUEST: "UPDATE_CRIMINALS_BY_ID_REQUEST",
  UPDATE_CRIMINALS_BY_ID_SUCCESS: "UPDATE_CRIMINALS_BY_ID_SUCCESS",
  UPDATE_CRIMINALS_BY_ID_FAILURE: "UPDATE_CRIMINALS_BY_ID_FAILURE",

  GET_CRIMINALS_TABLE_BY_ID_REQUEST: "GET_CRIMINALS_TABLE_BY_ID_REQUEST",
  GET_CRIMINALS_TABLE_BY_ID_SUCCESS: "GET_CRIMINALS_TABLE_BY_ID_SUCCESS",
  GET_CRIMINALS_TABLE_BY_ID_FAILURE: "GET_CRIMINALS_TABLE_BY_ID_FAILURE",

  SAVE_NEWS_REQUEST: "SAVE_NEWS_REQUEST",
  SAVE_NEWS_SUCCESS: "SAVE_NEWS_SUCCESS",
  SAVE_NEWS_FAILURE: "SAVE_NEWS_FAILURE",

  GET_NEWS_REQUEST: "GET_NEWS_REQUEST",
  GET_NEWS_SUCCESS: "GET_NEWS_SUCCESS",
  GET_NEWS_FAILURE: "GET_NEWS_FAILURE",

  UPDATE_NEWS_REQUEST: "UPDATE_NEWS_REQUEST",
  UPDATE_NEWS_SUCCESS: "UPDATE_NEWS_SUCCESS",
  UPDATE_NEWS_FAILURE: "UPDATE_NEWS_FAILURE",

  GET_GPS_INFORMATION_REQUEST: "GET_GPS_INFORMATION_REQUEST",
  GET_GPS_INFORMATION_SUCCESS: "GET_GPS_INFORMATION_SUCCESS",
  GET_GPS_INFORMATION_FAILURE: "GET_GPS_INFORMATION_FAILURE",

  GET_SPOT_REQUEST: "GET_SPOT_REQUEST",
  GET_SPOT_SUCCESS: "GET_SPOT_SUCCESS",
  GET_SPOT_FAILURE: "GET_SPOT_FAILURE",

  GET_SADYASTHITI_REQUEST: "GET_SADYASTHITI_REQUEST",
  GET_SADYASTHITI_SUCCESS: "GET_SADYASTHITI_SUCCESS",
  GET_SADYASTHITI_FAILURE: "GET_SADYASTHITI_FAILURE",

  GET_CREATE_PREVENT_REQUEST: "GET_CREATE_PREVENT_REQUEST",
  GET_CREATE_PREVENT_SUCCESS: "GET_CREATE_PREVENT_SUCCESS",
  GET_CREATE_PREVENT_FAILURE: "GET_CREATE_PREVENT_FAILURE",

  UPDATE_PREVENTIVE_BY_ID_REQUEST: "UPDATE_PREVENTIVE_BY_ID_REQUEST",
  UPDATE_PREVENTIVE_BY_ID_SUCCESS: "UPDATE_PREVENTIVE_BY_ID_SUCCESS",
  UPDATE_PREVENTIVE_BY_ID_FAILURE: "UPDATE_PREVENTIVE_BY_ID_FAILURE",

  GET_CRIMINALS_PLUS_BY_ID_REQUEST: "GET_CRIMINALS_PLUS_BY_ID_REQUEST",
  GET_CRIMINALS_PLUS_BY_ID_SUCCESS: "GET_CRIMINALS_PLUS_BY_ID_SUCCESS",
  GET_CRIMINALS_PLUS_BY_ID_FAILURE: "GET_CRIMINALS_PLUS_BY_ID_FAILURE",

  GET_CREATE_ARREST_REQUEST: "GET_CREATE_ARREST_REQUEST",
  GET_CREATE_ARREST_SUCCESS: "GET_CREATE_ARREST_SUCCESS",
  GET_CREATE_ARREST_FAILURE: "GET_CREATE_ARREST_FAILURE",

  GET_CREATE_NOTICE_REQUEST: "GET_CREATE_NOTICE_REQUEST",
  GET_CREATE_NOTICE_SUCCESS: "GET_CREATE_NOTICE_SUCCESS",
  GET_CREATE_NOTICE_FAILURE: "GET_CREATE_NOTICE_FAILURE",

  GET_UPDATE_ARREST_REQUEST: "GET_UPDATE_ARREST_REQUEST",
  GET_UPDATE_ARREST_SUCCESS: "GET_UPDATE_ARREST_SUCCESS",
  GET_UPDATE_ARREST_FAILURE: "GET_UPDATE_ARREST_FAILURE",

  GET_UPDATE_NOTICE_REQUEST: "GET_UPDATE_NOTICE_REQUEST",
  GET_UPDATE_NOTICE_SUCCESS: "GET_UPDATE_NOTICE_SUCCESS",
  GET_UPDATE_NOTICE_FAILURE: "GET_UPDATE_NOTICE_FAILURE",
};
